export default "__VITE_ASSET__8bb031f0__"